import clsx from 'clsx';
import { FC } from 'react';
import { Icon, IconType } from 'atoms/Icon';
import { Span } from 'atoms/Typography';
import styles from './styles.module.css';

export const LoadingIcon: FC<{
  text: string;
  classes: { root?: string; icon?: string; text?: string };
}> = ({ text, classes }) => {
  return (
    <div className={clsx(styles.root, classes.root)}>
      <Icon
        className={clsx(styles.icon, styles.iconHeart, classes.icon)}
        type={IconType.heart}
      />
      <Span className={clsx(styles.text, classes.text)}>{text}</Span>
    </div>
  );
};
